import { MARQUEE_ITEMS } from "@/data/exceptionHub";

const Dot = () => <span className="mx-8 h-1.5 w-1.5 rounded-full bg-brand/40 shrink-0" />;

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section className="py-10 md:py-14 border-y border-slate-100 bg-white overflow-hidden" data-testid="marquee">
      <div className="marquee-mask">
        <div className="flex w-max animate-marquee will-change-transform">
          {items.map((item, i) => (
            <div key={i} className="flex items-center">
              <span className="font-heading text-2xl md:text-4xl font-medium tracking-tight text-navy/90 whitespace-nowrap">{item}</span>
              <Dot />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
